module.exports = __webpack_public_path__ + "img/34.8afe74ba.png";